// import { useMemo, useState } from 'react';
// import { Modal, Button, Form, Spinner } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';

// type Props = {
//   show: boolean;
//   onHide: () => void;

//   chartOfAccountsId: any; // selectedacount
//   configEndpoint: string;

//   onConfigured?: (result?: any) => void; // callback after success
// };

// const ChartAccountsConfigModal = ({ show, onHide, chartOfAccountsId, configEndpoint, onConfigured }: Props) => {
//   const { i18n } = useTranslation();

//   const [postingConfig, setPostingConfig] = useState(false);
//   const [configError, setConfigError] = useState<string | null>(null);

//   const [maxLevel, setMaxLevel] = useState<number>(4);
//   const [levels, setLevels] = useState<Record<string, any>>({
//     level2: '',
//     level3: '',
//     level4: '',
//     level5: '',
//     level6: '',
//     level7: ''
//   });

//   const visibleLevelKeys = useMemo(() => {
//     const keys: string[] = [];
//     for (let i = 2; i <= maxLevel; i++) keys.push(`level${i}`);
//     return keys;
//   }, [maxLevel]);

//   const onChangeMaxLevel = (v: number) => {
//     setMaxLevel(v);

//     // تنظيف الحقول الأعلى من المستوى الجديد
//     setLevels(prev => {
//       const next = { ...prev };
//       for (let i = v + 1; i <= 7; i++) next[`level${i}`] = '';
//       return next;
//     });
//   };

//   const validateConfig = () => {
//     if (!chartOfAccountsId) return 'chartOfAccountsId required';

//     for (const k of visibleLevelKeys) {
//       const val = Number(levels[k]);
//       if (!Number.isFinite(val) || val <= 0) return `${k} required`;
//     }
//     return null;
//   };

//   const postConfig = async (payload: any) => {
//     const res = await fetch(configEndpoint, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload)
//     });

//     if (!res.ok) {
//       const txt = await res.text();
//       throw new Error(txt || 'Failed');
//     }

//     try {
//       return await res.json();
//     } catch {
//       return null;
//     }
//   };

//   const handleSubmitConfig = async () => {
//     setConfigError(null);

//     const err = validateConfig();
//     if (err) {
//       setConfigError(i18n.language === 'ar' ? 'تحقق من إدخال جميع الحقول المطلوبة' : 'Please fill all required fields');
//       return;
//     }

//     const payload: any = {
//       chartOfAccountsId,
//       maxLevel
//     };

//     // فقط المستويات الظاهرة
//     visibleLevelKeys.forEach(k => {
//       payload[k] = Number(levels[k]);
//     });

//     try {
//       setPostingConfig(true);
//       const result = await postConfig(payload);
//       onHide();
//       onConfigured?.(result);
//     } catch (e: any) {
//       setConfigError(e?.message || 'Error');
//     } finally {
//       setPostingConfig(false);
//     }
//   };

//   return (
//     <Modal show={show} onHide={onHide} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>{i18n.language === 'ar' ? 'إعداد الدليل المحاسبي' : 'Chart Accounts Configuration'}</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         {configError && <div className='alert alert-danger py-2 mb-3'>{configError}</div>}

//         <Form.Group className='mb-3'>
//           <Form.Label>{i18n.language === 'ar' ? 'عدد المستويات (maxLevel)' : 'Max Level'}</Form.Label>
//           <Form.Select value={maxLevel} onChange={e => onChangeMaxLevel(Number(e.target.value))} disabled={postingConfig}>
//             <option value={4}>4</option>
//             <option value={5}>5</option>
//             <option value={6}>6</option>
//             <option value={7}>7</option>
//           </Form.Select>
//         </Form.Group>

//         <div className='row'>
//           {visibleLevelKeys.map(k => (
//             <div className='col-12 col-md-6 mb-3' key={k}>
//               <Form.Group>
//                 <Form.Label>
//                   {i18n.language === 'ar' ? `عدد السيجمنت لـ ${k}` : `Segments count for ${k}`}
//                 </Form.Label>
//                 <Form.Control
//                   type='number'
//                   min={1}
//                   value={levels[k]}
//                   onChange={e => setLevels(prev => ({ ...prev, [k]: e.target.value }))}
//                   disabled={postingConfig}
//                 />
//               </Form.Group>
//             </div>
//           ))}
//         </div>

//         <div className='text-muted small'>
//           {i18n.language === 'ar'
//             ? 'سيتم إرسال level2..level7 حسب المستوى المختار.'
//             : 'Will post level2..level7 based on the selected max level.'}
//         </div>
//       </Modal.Body>

//       <Modal.Footer>
//         <Button variant='secondary' onClick={onHide} disabled={postingConfig}>
//           {i18n.language === 'ar' ? 'إلغاء' : 'Cancel'}
//         </Button>
//         <Button variant='primary' onClick={handleSubmitConfig} disabled={postingConfig}>
//           {postingConfig ? <Spinner size='sm' animation='border' /> : i18n.language === 'ar' ? 'حفظ' : 'Save'}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ChartAccountsConfigModal;

import { Card } from '@components/card/card';
import { useMemo, useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
  show: boolean;
  onHide: () => void;
  chartOfAccountsId: any;
  configEndpoint: string;
  onConfigured?: (result?: any) => void;
};

const ChartAccountsConfigModal = ({ show, onHide, chartOfAccountsId, configEndpoint, onConfigured }: Props) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const [postingConfig, setPostingConfig] = useState(false);
  const [configError, setConfigError] = useState<string | null>(null);

  const [maxLevel, setMaxLevel] = useState<number>(4);
  const [levels, setLevels] = useState<Record<string, any>>({
    level2: '1',
    level3: '1',
    level4: '1',
    level5: '1',
    level6: '1',
    level7: '1'
  });

  const visibleLevelKeys = useMemo(() => {
    const keys: string[] = [];
    for (let i = 2; i <= maxLevel; i++) keys.push(`level${i}`);
    return keys;
  }, [maxLevel]);

  const allFieldsFilled = useMemo(
    () => visibleLevelKeys.every(k => levels[k] && Number(levels[k]) > 0),
    [visibleLevelKeys, levels]
  );

  const filledCount = useMemo(
    () => visibleLevelKeys.filter(k => levels[k] && Number(levels[k]) > 0).length,
    [visibleLevelKeys, levels]
  );

  const onChangeMaxLevel = (v: number) => {
    setMaxLevel(v);
    setLevels(prev => {
      const next = { ...prev };
      for (let i = v + 1; i <= 7; i++) next[`level${i}`] = '';
      return next;
    });
  };

  const handleLevelChange = (level: string, value: string) => {
    const numValue = Math.max(1, parseInt(value) || 1);
    setLevels(prev => ({ ...prev, [level]: numValue }));
  };

  const validateConfig = () => {
    if (!chartOfAccountsId) return isRTL ? 'يجب تحديد الدليل المحاسبي' : 'Chart of accounts required';
    if (!allFieldsFilled) return isRTL ? 'املأ جميع الحقول المطلوبة' : 'Fill all required fields';
    return null;
  };

  const postConfig = async (payload: any) => {
    const res = await fetch(configEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || 'Request failed');
    }

    try {
      return await res.json();
    } catch {
      return null;
    }
  };

  const handleSubmitConfig = async () => {
    setConfigError(null);

    const err = validateConfig();
    if (err) {
      setConfigError(err);
      return;
    }

    const payload: any = {
      chartOfAccountsId,
      maxLevel
    };

    visibleLevelKeys.forEach(k => {
      payload[k] = Number(levels[k]);
    });

    try {
      setPostingConfig(true);
      const result = await postConfig(payload);
      onHide();
      onConfigured?.(result);
    } catch (e: any) {
      setConfigError(e?.message || (isRTL ? 'حدث خطأ أثناء الحفظ' : 'An error occurred'));
    } finally {
      setPostingConfig(false);
    }
  };

  // ✅ دالة لتحديد لون الحالة
  const getStatusColor = () => {
    if (!allFieldsFilled) return 'warning';
    if (postingConfig) return 'info';
    return 'success';
  };

  // ✅ دالة لتحديد أيقونة الحالة
  const getStatusIcon = () => {
    if (!allFieldsFilled) return 'bi-exclamation-circle';
    if (postingConfig) return 'bi-arrow-repeat';
    return 'bi-check-circle';
  };

  // ✅ دالة لتحديد نص الحالة
  const getStatusText = () => {
    if (!allFieldsFilled) return isRTL ? 'مطلوب تعبئة الحقول' : 'Fields required';
    if (postingConfig) return isRTL ? 'جاري الحفظ...' : 'Saving...';
    return isRTL ? 'جاهز للحفظ' : 'Ready to save';
  };

  return (
    <Modal show={show} onHide={onHide} centered size='md' backdrop='static' className='fade'>
      {/* ✅ رأس المودال بنفس روح التصميم */}
      <div className='modal-header border-0 bg-theme bg-opacity-10 px-4 pt-4 pb-3'>
        <div className='d-flex align-items-center w-100'>
          <div className={` p-2 me-3`}>
            <i className='bi bi-sliders text-theme' style={{ fontSize: '1.6rem' }}></i>
          </div>
          <div className='flex-grow-1'>
            <h5 className='modal-title fw-bold mb-0'>
              {isRTL ? 'إعداد مستويات الدليل المحاسبي' : 'Chart of Accounts Levels Setup'}
            </h5>
            <p className='text-muted small mb-0 mt-1'>
              <i className='bi bi-info-circle me-1'></i>
              {isRTL
                ? 'تحديد عدد المستويات وقطعها لتصميم هيكل الدليل'
                : 'Set the number of levels and segments for your chart structure'}
            </p>
          </div>
          <button
            type='button'
            className='btn-close'
            onClick={onHide}
            disabled={postingConfig}
            aria-label='Close'
          ></button>
        </div>
      </div>

      <div className='modal-body px-4 py-3'>
        {/* ✅ رسالة الخطأ */}
        {configError && (
          <div className='alert alert-danger border-0 bg-danger bg-opacity-10 text-danger d-flex align-items-center mb-4 py-2 px-3'>
            <i className='bi bi-x-circle-fill me-2 flex-shrink-0'></i>
            <div className='small'>{configError}</div>
          </div>
        )}

        <div className='row g-4'>
          {/* ✅ قسم عدد المستويات */}
          <div className='col-12'>
            <div className='card border-0 shadow-sm'>
              <div className='card-header  border-bottom py-2'>
                <h6 className='mb-0 small fw-semibold'>
                  <i className='bi bi-layers me-2'></i>
                  {isRTL ? 'عدد المستويات' : 'Number of Levels'}
                </h6>
              </div>
              <div className='card-body p-3'>
                <div className='d-flex justify-content-center'>
                  <div className='btn-group btn-group' role='group'>
                    {[4, 5, 6, 7].map(num => (
                      <button
                        key={num}
                        type='button'
                        className={`btn ${maxLevel === num ? 'btn-theme' : 'btn-outline-secondary'}`}
                        onClick={() => onChangeMaxLevel(num)}
                        disabled={postingConfig}
                      >
                        <span className='fw-semibold'>{num}</span>
                        <span className='ms-1 small'>{isRTL ? 'مستوى' : 'Levels'}</span>
                      </button>
                    ))}
                  </div>
                </div>
                <div className='text-center text-muted small mt-2'>
                  <i className='bi bi-lightbulb me-1'></i>
                  {isRTL
                    ? 'اختر العدد المناسب لهيكل حسابك'
                    : 'Choose the appropriate number for your account structure'}
                </div>
              </div>
            </div>
          </div>

          {/* ✅ قسم تفاصيل المستويات */}
          <div className='col-12'>
            <div className='card border-0 shadow-sm'>
              <div className='card-header border-bottom py-2 d-flex justify-content-between align-items-center'>
                <h6 className='mb-0 small fw-semibold'>
                  <i className='bi bi-input-cursor me-2'></i>
                  {isRTL ? 'عدد القطع لكل مستوى' : 'Segments per Level'}
                </h6>
                <span className='badge bg-theme bg-opacity-10 text-theme'>
                  {filledCount}/{visibleLevelKeys.length}
                </span>
              </div>
              <div className='card-body p-3'>
                <div className='row g-3'>
                  {visibleLevelKeys.map(k => {
                    const levelNum = k.replace('level', '');
                    const isFilled = levels[k] && Number(levels[k]) > 0;

                    return (
                      <div className='col-6' key={k}>
                        <Card>
                          <div className={` ${isFilled ? 'border-theme' : 'border-light'} transition-all`}>
                            <div className='card-body '>
                              <div className='d-flex justify-content-between align-items-center mb-2'>
                                <label className='form-label small fw-semibold mb-0'>
                                  {isRTL ? `المستوى ${levelNum}` : `Level ${levelNum}`}
                                </label>
                                {isFilled && <i className='bi bi-check-circle text-success small'></i>}
                              </div>
                              <div className='input-group'>
                                <input
                                  type='number'
                                  min='1'
                                  placeholder='1'
                                  className={`form-control ${isFilled ? 'border-theme' : ''}`}
                                  value={levels[k] || ''}
                                  onChange={e => handleLevelChange(k, e.target.value)}
                                  disabled={postingConfig}
                                />
                                <span className='input-group-text border-start-0'>
                                  <i className='bi bi-hash text-muted'></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* ✅ شريط الحالة */}
          <div className='col-12'>
            <div
              className={`alert alert-${getStatusColor()} border-0 bg-${getStatusColor()} bg-opacity-10 d-flex align-items-center py-2 px-3`}
            >
              <i className={`bi ${getStatusIcon()} text-${getStatusColor()} me-2 flex-shrink-0`}></i>
              <div className='flex-grow-1'>
                <div className='small fw-semibold'>{getStatusText()}</div>
                {!allFieldsFilled && (
                  <div className='progress mt-1' style={{ height: '4px' }}>
                    <div
                      className={`progress-bar bg-${getStatusColor()}`}
                      style={{ width: `${(filledCount / visibleLevelKeys.length) * 100}%` }}
                    ></div>
                  </div>
                )}
              </div>
              <div className='text-end'>
                <div className='fw-bold'>
                  {filledCount}/{visibleLevelKeys.length}
                </div>
                <div className='text-muted small'>{isRTL ? 'مكتمل' : 'Complete'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ تذييل المودال */}
      <div className='modal-footer border-0 px-4 pb-4 pt-3'>
        <div className='d-flex justify-content-between w-100 gap-3'>
          <Button
            variant='outline-secondary'
            onClick={onHide}
            disabled={postingConfig}
            className='d-flex align-items-center px-4'
          >
            <i className='bi bi-x-lg me-2'></i>
            {isRTL ? 'إلغاء' : 'Cancel'}
          </Button>

          <Button
            variant={allFieldsFilled ? 'theme' : 'secondary'}
            onClick={handleSubmitConfig}
            disabled={postingConfig || !allFieldsFilled}
            className='d-flex align-items-center justify-content-center px-4 flex-grow-1'
          >
            {postingConfig ? (
              <>
                <Spinner as='span' animation='border' size='sm' className='me-2' />
                <span>{isRTL ? 'جاري الحفظ...' : 'Saving...'}</span>
              </>
            ) : (
              <>
                <i className='bi bi-check-circle me-2'></i>
                <span>{isRTL ? 'حفظ الإعدادات' : 'Save Configuration'}</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChartAccountsConfigModal;
